import { useMutation, useQueryClient } from "@tanstack/react-query";

import { type CreateHolidayInput, createHoliday } from "@/adapters/api";
import { useActiveContext } from "@/store/use-active-context";
import { invalidateHolidayQueries } from "./invalidate-holidays";

export function useCreateHoliday() {
	const queryClient = useQueryClient();
	const activeCanteiroId = useActiveContext((state) => state.activeCanteiroId);

	return useMutation({
		mutationFn: (input: CreateHolidayInput) =>
			createHoliday(activeCanteiroId as string, input),
		onSuccess: () => invalidateHolidayQueries(queryClient),
	});
}
